import React, { useState, useEffect } from "react";
import "./App.css";
import Dashboard from "./components/Dashboard";
import { auth, googleProvider } from "./firebase";
import {
  onAuthStateChanged,
  signInWithPopup,
} from "firebase/auth";
import loader from "./images/loader.gif";

const App = () => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setUser(user);
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  const handleLogin = async () => {
    try {
      await signInWithPopup(auth, googleProvider);
    } catch (error) {
      console.error("Login failed:", error);
    }
  };

  if (loading) {
    return (
      <div className="loading-overlay">
        <img src={loader} alt="Loading..." />
      </div>
    );
  }

  if (!user) {
    return (
      <div className="loading-overlay" style={{ flexDirection: 'column', gap: '24px' }}>
        <h1 style={{ marginBottom: 0 }}>Wordly Dashboard</h1>
        <p style={{ color: 'var(--text-muted)' }}>Sign in to manage the application</p>
        <button className="primary-btn" onClick={handleLogin} style={{ padding: '14px 28px', fontSize: '1.1rem' }}>
          Sign in with Google
        </button>
      </div>
    );
  }

  const authorizedEmails = ["liavkuperman@gmail.com", "ronnyasraf6@gmail.com"];
  if (!authorizedEmails.includes(user.email)) {
    return (
      <div className="loading-overlay" style={{ flexDirection: 'column', gap: '16px' }}>
        <h2 style={{ color: 'var(--error)' }}>Access Denied</h2>
        <p>Your email <strong>{user.email}</strong> is not authorized.</p>
        <button className="danger-btn" onClick={() => auth.signOut()}>
          Sign Out
        </button>
      </div>
    );
  }

  return <Dashboard />;
};

export default App;
